import { Routes } from '@angular/router';
import { PaymentHomeComponent } from './payment-home/payment-home.component';
import { ReceivableSearchResultsComponent } from './receivable-search-results/receivable-search-results.component';
import { FeePaymentOptionsComponent } from './fee-payment-options/fee-payment-options.component';

export const routes: Routes = [
    { path: '', redirectTo: 'payment-home', pathMatch: 'full' },
    { path: 'payment-home', component: PaymentHomeComponent },
    { path: 'invoice-list', component: ReceivableSearchResultsComponent },
    { path: 'fee-payment-options', component: FeePaymentOptionsComponent }
];
